module.exports = __webpack_public_path__ + "img/cross-dark.b7ecd6b.svg";